<script>
	import { page } from '$app/stores'
	import { t } from '$lib/translations'
	import { Button } from './index.js'
	import { Thumbnails } from '../modules/reference/index.js'

	export let header = null
	export let references = null
	export let brands = null
	export let regionName = null
	export let cityName = null
	export let cities = null
	export let deviceType = null
	export let referencesOnlyImages = null
	export let transparent = false
	export let reverse = false
	export let padding = null
	export let headerAsterisk = false
	export let noShrink = false

	const { city, region } = $page.params
	export let thumbTitle = {
		text:
			cityName || regionName
				? t('web.components.THUMBNAILS.headingRegion', {
						region: cityName || regionName
				  })
				: t('web.components.THUMBNAILS.heading'),
		textAlign: 'left'
	}
</script>

<div style:padding class="background" class:hp={$page.url.pathname === '/'} class:transparent>
	<div class="header-wrapper">
		<div class="wrapper-up" class:reverse>
			<div class="header {noShrink ? 'no-shrink' : ''}">
				{#if header.supheading}
					<h5 class="text-red mb-0 uppercase">{t(header.supheading)}</h5>
				{/if}
				<h1 class="{header.supheading ? 'mt-0' : ''} !text-6xl-res font-extrabold !tracking-normal">
					{@html headerAsterisk
						? `${t(header.heading)} <span class=text-primary-500>&nbsp;&ast;</span>`
						: `${t(header.heading)} ${cityName || regionName || ''}`}
				</h1>
				{#if header?.subheading}
					<p class="font-regular text-1.5xl-res mb-8 mt-6 leading-normal tracking-wide">
						{@html t(header.subheading)}
					</p>
				{/if}
				{#if header.buttons}
					{#each header.buttons as { success, href, name, secondary, shadow, noWrap, icon, testId }}
						<div>
							<Button columnGroup {success} {shadow} {secondary} {href} {icon} {noWrap} {testId}
								>{name}</Button
							>
						</div>
					{/each}
				{/if}
				<slot name="buttons" />
				{#if header?.subtext}
					<p class="subtext mt-8 text-base">
						{@html t(header.subtext)}
					</p>
				{/if}
				<slot />
			</div>
			{#if header?.main_image}
				<div class="img-wrapper">
					<img
						class="overflow-visible"
						src={t(header.main_image?.url)}
						alt={t(header.main_image?.alternativeText)}
					/>
				</div>
			{:else if references}
				<div class="latest-installation-cont {noShrink ? 'no-shrink' : ''}">
					<Thumbnails
						{referencesOnlyImages}
						{references}
						title={thumbTitle}
						titleFontSize="4xl"
						titleWeight="normal"
						overflowPage
						noPaddingLeft
						noDetail
					/>
					{#if header?.references_subtext}
						<p
							class="references-data max-w-[90vw] text-lg-res {noShrink
								? 'lg:max-w-[25vw] xl:max-w-[40vw]'
								: ''}"
						>
							{@html t(header?.references_subtext)}
						</p>
					{/if}
					{#if brands?.length}
						<div class="container-flex mt-3">
							{#each brands as brand}
								<a href="/{deviceType}/{brand.slug}">
									<img src={brand?.logo[0]?.url} alt={brand?.logo[0]?.alternativeText} />
								</a>
							{/each}
						</div>
					{/if}
				</div>
			{/if}
		</div>

		{#if header.banner == 'main'}
			<div class="banner">
				<div class="text">
					<div class="textUp">
						<span>Pompy ciepła i panele fotowoltaiczne od Woltair dostępne na kredyt.</span>
					</div>
					<div class="textDown"><span>Minimum formalności. Atrakcyjne warunki.</span></div>
				</div>
				<div class="button">
					<a
						href="https://www.woltair.pl/artykuly/o-woltair/kredyt-na-fotowoltaike-lub-pompe-ciepla-jakie-warunki-nalezy-spelnic"
					>
						Zobacz
					</a>
				</div>
			</div>
		{/if}
		{#if header.banner == 'hvac'}
			<div class="banner">
				<div class="text">
					<div class="textUp"><span>Pompy ciepła od Woltair dostępne na kredyt.</span></div>
					<div class="textDown"><span>Minimum formalności. Atrakcyjne warunki.</span></div>
				</div>
				<div class="button">
					<a
						href="https://www.woltair.pl/artykuly/o-woltair/kredyt-na-fotowoltaike-lub-pompe-ciepla-jakie-warunki-nalezy-spelnic"
					>
						Zobacz
					</a>
				</div>
			</div>
		{/if}
		{#if header.banner == 'fvac'}
			<div class="banner">
				<div class="text">
					<div class="textUp">
						<span>Panele fotowoltaiczne od Woltair dostępne na kredyt.</span>
					</div>
					<div class="textDown"><span>Minimum formalności. Atrakcyjne warunki.</span></div>
				</div>
				<div class="button">
					<a
						href="https://www.woltair.pl/artykuly/o-woltair/kredyt-na-fotowoltaike-lub-pompe-ciepla-jakie-warunki-nalezy-spelnic"
					>
						Zobacz
					</a>
				</div>
			</div>
		{/if}

		{#if region && !city && region !== 'praha'}
			<div class="mt-4 text-center">
				<h4 class="mb-8">Montáže dle města:</h4>
				<div class="text-center">
					{#each cities as city, _index}
						{#if _index < 5}
							<a
								class="mb-4 mr-4 inline-block rounded-lg bg-white p-4 text-neutral-800 shadow-lg hover:text-primary-500"
								href="/{deviceType}/{region}/{city?.slug}"
							>
								{city?.name}
							</a>
						{:else if _index === 5}
							<details class="detail inline">
								<summary class="cursor-pointer">
									<div
										class="mb-4 mr-4 rounded-lg bg-white p-4 text-neutral-800 shadow-lg hover:text-primary-500"
									>
										Další
									</div>
								</summary>
								{#each cities.slice(_index) as city}
									<a
										class="mb-4 mr-4 inline-block rounded-lg bg-white p-4 text-neutral-800 shadow-lg hover:text-primary-500"
										href="/{deviceType}/{region}/{city?.slug}"
									>
										{city?.name}
									</a>
								{/each}
							</details>
						{/if}
					{/each}
				</div>
			</div>
		{/if}
	</div>
</div>

<style lang="scss">
	details {
		summary {
			list-style: none;
		}
		&[open] {
			summary::-webkit-details-marker,
			summary::marker {
				display: none;
			}
			summary div {
				display: none;
			}
		}
	}
	.background {
		width: 100%;
		position: relative;
		z-index: 2;
		background: #f4f4f4;
		left: 50%;
		transform: translateX(-50%);

		@media only screen and (max-width: 760px) {
			padding-bottom: 0;
		}

		&.hp {
			margin-top: -80px;
			padding-top: 80px;
			background-size: cover;
			background-repeat: no-repeat;
			background-position: top right;
			background-image: url('$static/images/logos/woltair-background.svg');

			@media only screen and (max-width: 760px) {
				background-image: url('$static/images/logos/woltair-background-mobile.svg');
				background-position: top center;
			}
		}

		&.transparent {
			background: transparent;
		}

		.header-wrapper {
			margin-bottom: 25px;
			margin-top: 40px;
			display: flex;
			flex-direction: column;
			padding: 50px 15px;
			width: 100%;
			max-width: 1360px;
			margin: 0 auto;
			width: 100%;

			@media only screen and (max-width: 760px) {
				padding: 20px 15px 20px;
			}

			.wrapper-up {
				display: flex;
				flex-direction: column;

				@screen md {
					flex-direction: row;
					gap: 20px;
				}

				@screen lg {
					gap: 100px;
				}

				&.reverse {
					@screen lg {
						flex-direction: row-reverse;
					}
				}
			}

			.header {
				width: 100%;
				flex-shrink: 0;
				@screen sm {
					width: 50%;
				}

				&.no-shrink {
					@screen sm {
						min-width: 660px;
					}
				}

				h1 {
					margin-bottom: 10px;
					margin-top: 20px;

					@screen sm {
						margin-top: 0;
					}
				}
			}

			.img-wrapper {
				width: 100%;
				margin-top: 30px;

				@screen md {
					width: 50%;
					margin-top: 0;
				}

				img {
					width: 100%;
					height: auto;
					display: block;
				}
			}
		}
	}

	.latest-installation-cont {
		width: 100vw;
		margin-top: 10px;
		flex-shrink: 0;
		flex-grow: 0;
		position: relative;
		padding-top: 28px;

		@screen sm {
			margin-top: 0px;
		}

		&.no-shrink {
			margin-top: 2rem;
			@screen sm {
				width: 100%;
			}

			@screen lg {
				width: 50vw;
				margin-top: 0px;
			}
		}
	}
	.container-flex {
		width: 50vw;
		flex-shrink: 0;
		flex-grow: 0;
		position: relative;
		left: 0;
		height: 50px;
		overflow-x: auto;
		overflow-y: hidden;
		display: flex;
		-ms-overflow-style: none;
		scrollbar-width: none;
		gap: 15px;
		padding: 0 50px;

		@media only screen and (max-width: 760px) {
			width: 100vw;
		}

		&::-webkit-scrollbar {
			display: none;
		}

		a {
			flex-shrink: 0;
		}

		img {
			height: 35px;
		}
	}

	.banner {
		background-color: rgb(226, 6, 19);
		display: grid;
		grid-template-rows: 1fr;
		grid-template-areas: 'text button';
		border-radius: 15px;
		margin-top: 100px;
		width: 70%;
	}

	.text {
		display: grid;
		grid-template: 1fr / 1fr;
		grid-area: text / text / text / text;
		font-family: Sora;
		font-size: 1.875rem;
		font-weight: 800;
		padding-left: 20px;
	}

	.text span {
		color: white;
		font-size: 18px;
		font-weight: bold;
	}

	.button {
		grid-area: button / button / button / button;
	}

	.button a {
		background-color: black;
		padding: 14px 24px;
		border-radius: 20px;
		text-decoration: none;
		color: white;
	}

	@media only screen and (max-width: 767px) {
		.text {
			font-size: 1.5rem;
			padding-left: 10px;
			margin-bottom: -10px;
		}

		.text span {
			font-size: 16px;
		}

		.button a {
			padding: 10px 20px;
		}

		.banner {
			width: 100%;
			margin-top: 50px;
			border-radius: 10px;
			grid-template-areas:
				'text'
				'button';
			grid-template-columns: 1fr;
			grid-template-rows: auto auto;
		}
	}
</style>
